module.exports = __webpack_public_path__ + "img/5.08e4ba93.png";